function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3332 8.33301H26.6665C29.7607 8.33301 32.7282 9.56217 34.9161 11.7501C37.104 13.938 38.3332 16.9055 38.3332 19.9997C38.3332 23.0939 37.104 26.0613 34.9161 28.2493C32.7282 30.4372 29.7607 31.6663 26.6665 31.6663H13.3332C10.239 31.6663 7.27152 30.4372 5.08359 28.2493C2.89567 26.0613 1.6665 23.0939 1.6665 19.9997C1.6665 16.9055 2.89567 13.938 5.08359 11.7501C7.27152 9.56217 10.239 8.33301 13.3332 8.33301ZM26.6665 24.9997C27.9926 24.9997 29.2644 24.4729 30.202 23.5352C31.1397 22.5975 31.6665 21.3258 31.6665 19.9997C31.6665 18.6736 31.1397 17.4018 30.202 16.4641C29.2644 15.5265 27.9926 14.9997 26.6665 14.9997C25.3404 14.9997 24.0686 15.5265 23.131 16.4641C22.1933 17.4018 21.6665 18.6736 21.6665 19.9997C21.6665 21.3258 22.1933 22.5975 23.131 23.5352C24.0686 24.4729 25.3404 24.9997 26.6665 24.9997Z",
  fill: "#010028"
});

function SvgStep4Mobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Mobile);
export default __webpack_public_path__ + "static/media/step4-mobile.20a6fbee.svg";
export { ForwardRef as ReactComponent };